import { useTranslation } from "react-i18next";
import { FlowBoxButton, FlowBox } from "melco-ui";
import { InputField, DisplayFormErrors } from "melco-shared-logic";
import { Form, FormikProps } from "formik";
import { LoginFormValueType } from "./LoginForm";
import LoginFormStatusMessage from "./LoginFormStatusMessage";



export const DisplayLoginForm: React.FC<FormikProps<LoginFormValueType>> = ({
  isSubmitting,
}) => {
  const { t } = useTranslation();


  return (

    <Form style={{ width: '380px' }}>
      <LoginFormStatusMessage />

      <DisplayFormErrors />

      <FlowBox>
        <InputField
          name="user_name"
          size="large"
          placeholder={t("login.form.inputs.email")}
          autoComplete="username"
        />
        <InputField
          name="password"
          size="large"
          placeholder={t("login.form.inputs.password")}
          type="password"
          autoComplete="current-password"
        />

        {/* <ForgotPasswordParagraph
          size="small"
          alignment="right"
          type="secondary"
        >
          {t("loginpage.forgotpassword.text")}{" "}
          <Link to="/forgotpassword">{t("loginpage.forgotpassword.link")}</Link>
        </ForgotPasswordParagraph> */}

        <FlowBoxButton
          loading={isSubmitting}
          disabled={isSubmitting}
          htmlType="submit"
        >
          {t("login.form.submit")}
        </FlowBoxButton>
      </FlowBox>
    </Form>

  );
};
